// Messaging bridge to the host page that embeds this app in an SDK iframe.
//
// Outbound postMessage calls are locked to the host page's origin instead of '*'
// so a message can never be delivered to an unexpected parent window. The origin
// is captured from the browser-verified `event.origin` of the SDK's config
// messages (see RootLayout); until that arrives we fall back to document.referrer
// (the embedding page), and only then to '*' (e.g. the very first IFRAME_READY
// when the host strips the referrer).

let capturedParentOrigin = null;

export const isEmbeddedInIframe = () => typeof window !== 'undefined' && window.parent !== window;

/**
 * The window the web SDK runs in: the parent page in iframe mode, the opener
 * in popout mode (the SDK opened this popup with window.open). Null when the
 * page was opened on its own (a link copied into a new tab) — nothing to talk to.
 */
export const getSdkHostWindow = () => {
  let host = null;
  if (isEmbeddedInIframe()) host = window.parent;
  else if (window.opener && !window.opener.closed) host = window.opener;
  return host;
};

// Sandboxed iframes report the literal string 'null' — not a usable targetOrigin.
export const captureParentOrigin = (origin) => {
  if (origin && origin !== 'null') capturedParentOrigin = origin;
};

export const getParentOrigin = () => {
  if (capturedParentOrigin) return capturedParentOrigin;
  try {
    if (document.referrer) return new URL(document.referrer).origin;
  } catch (error) { /* malformed referrer — fall through to '*' */ }
  return '*';
};

export const postMessageToParentSDK = (eventType, data = {}) => {
  if (!isEmbeddedInIframe()) return;
  window.parent.postMessage({ eventType, data }, getParentOrigin());
};
